import React, {Component} from 'react';

class BoxInput extends Component{
    triggerFocus(){ this.nameInput.focus()};



    render() {

        const safariStyle = {
            paddingTop: (( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) ? "'0px'":"'5px'" ),
        };

        return (
            <input
                ref={(input) => { this.nameInput = input; }}
                className={"form_input "+this.props.classNames}
                placeholder={this.props.placeholder}
                size={this.props.size}
                autoFocus={this.props.autoFocus}
                value={this.props.value}
                onChange={this.props.changeAction}
                onKeyDown={(e) => {
                    if (this.props.keyDownAction) {
                        this.props.keyDownAction(e);
                    }
                }}
                onMouseDown={(e) => {
                    if (this.props.mouseDownAction) {
                        this.props.mouseDownAction(e);
                    }
                }}
                onClick={(e) => {
                    if (this.props.clickAction) {
                        this.props.clickAction(e);
                    }
                }}
                onFocus={() => {
                    if (this.props.focusAction) {
                        this.props.focusAction();
                    }
                }}

                ref={ input => input && this.props.focus && input.focus()}

                style={safariStyle}
            />
        )
    }
}

export default BoxInput;